module.exports = __webpack_public_path__ + "img/1508608142.93e09535.jpg";